const breakfast = [
    {
        id: 1,
        name: 'Pequeno almoço OM Grill',
        description: 'Ovos mexidos, cogumelos, salsichas, tomate, fiambre',
        price: '6.000'
    },
    {
        id: 2,
        name: 'Omelete Misto',
        description: 'Fiambre, queijo, ovos batata frita',
        price: '3.000'
    },
    {
        id: 3,
        name: 'combo grill',
        description: 'Tosta grill, sumo nataural, batata frita',
        price: '6.500'
    }
];

export default breakfast;